(function(){
  const root = document.querySelector('.calc-wrapper[data-calc="airsoft"]');
  if (!root) return;

  const w   = root.querySelector('#go-weight');
  const v   = root.querySelector('#go-vel');
  const u   = root.querySelector('#go-unit');
  const out = root.querySelector('#go-result');
  const btn = root.querySelector('#go-calc');
  const rst = root.querySelector('#go-reset');

  const FPS_TO_MS = 0.3048;
  const num = s => parseFloat(String(s||'').replace(',', '.'));

  const fmt2 = new Intl.NumberFormat('nb-NO', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  const fmt1 = new Intl.NumberFormat('nb-NO', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  const fmt3 = new Intl.NumberFormat('nb-NO', { minimumFractionDigits: 1, maximumFractionDigits: 1 });

  function calc(){
    const weight = num(w.value);
    const vel    = num(v.value);
    const unit   = u.value;

    if (isNaN(weight) || weight <= 0 || isNaN(vel) || vel < 0){
      out.textContent = 'Vennligst fyll inn gyldige tallverdier.'; 
      return;
    }

    const velMs  = unit === 'fps' ? vel * FPS_TO_MS : vel;
    const velFps = unit === 'ms'  ? vel / FPS_TO_MS : vel;
    const joule  = 0.5 * (weight/1000) * velMs * velMs;

    out.innerHTML = `Hastighet: ${fmt2.format(velMs)} m/s (${fmt1.format(velFps)} FPS)<br>` +
                    `Energi: ${fmt3.format(joule)} J`;
  }

  function reset(){
    w.value = ''; 
    v.value = ''; 
    u.value = 'ms'; 
    out.textContent = '';
  }

  btn?.addEventListener('click', calc);
  rst?.addEventListener('click', reset);
})();
